module.exports = {
    acompanhanteRegistrado: 'Acompanhante já registrado',
    administrativo: 'Administrativo',
    administrativo: 'Administrativo',
    administrativo: 'Administrativo',
    alertaResponsavelCadsus: 'Os dados do responsável foram importados do Cartão Nacional do SUS. Preencha seu contato e clique em "Cadastrar" para continuar.',
    alertaSolicitacaoDuplicada: 'Foi identificado que este paciente possui uma solicitação encaminhada. Você deseja continuar mesmo assim?',
    alertaSolicitacaoDuplicada: 'Já existe uma solicitação de avaliação clínica encaminhada para este paciente. Você deseja continuar?',
    alterarAvaliacaoClinica: 'Alterar avaliação clínica',
    amarelo: 'Amarelo',
    ambos: 'Ambos',
    assistenciaConsideravel: "Assistência considerável",
    assistenciaOcasional: 'Assistência ocasional',
    assistenciaQuaseCompleta: 'Assistência quase completa',
    atencaoAdicaoAnexos: 'Anexe aqui os documentos do paciente para a avaliação clínica.',
    atencaoAnexosObrigatorios: 'Os documentos de identidade com CPF, cartão nacional de saúde, comprovante de residência, termo de responsabilidade SMS, assinado e resultado da gasometria arterial são obrigatórios.',
    atividadeEvidenciaDoenca: "Atividade e evidência de doença",
    autoCuidado: 'Autocuidado',
    autorizacao: 'Autorização',
    autorizacaoServico: 'Autorização de serviço',
    autorizacaoServico: 'Autorização de serviço',
    autorizacaoServico: 'Autorização de serviço',
    autorizado: 'Autorizado',
    autorizando: 'Autorizando',
    autorizar: 'Autorizar',
    avaliacaoClinica: 'Avaliação clínica',
    azul: 'Azul',
    be: 'BE',
    processoNaFila: 'O processo se encontra na fila para emissão da G.A.S.',
    processoComGas: 'O processo já possui G.A.S. emitida.',
    be: 'BE',
    buscandoResponsaveis: 'Buscando responsáveis',
    buscarResponsavel: 'Buscar responsável',
    cadastroAcompanhante: 'Deseja cadastrar um novo responsavel?',
    cancelado: 'Cancelado',
    cancelamento: 'Cancelamento',
    cancelando: 'Cancelando',
    cardiopatias: 'Cardiopatias',
    carregandoAvaliacaoClinica: 'Carregando avaliação clínica',
    classificacaoRisco: 'Classificação de risco',
    cnpj: 'CNPJ',
    cnpjEmpresaGas: 'CNPJ da empresa responsável',
    coma: 'Sonolência ou coma +/- confusão',
    complementoEstacionario: 'O processo atual possui um equipamento estacionário vinculado: ',
    complementoPortatil: 'O processo atual possui um equipamento portátil vinculado: ',
    completa: 'Completa',
    completo: 'Completo',
    confirmarSolicitarEquipamento: 'Você confirma a solicitação do equipamento?',
    contato: 'Contato',
    contatoEmpresaGas: 'Contato da empresa responsável',
    contatoEmpresaGas: 'Contato da empresa responsável',
    contatoEmpresaGas: 'Contato da empresa responsável',
    contatosTecnicoResponsavel: 'Contatos do responsável pela unidade',
    cuidados: 'Cuidados com a boca',
    dataExame: 'Data do exame',
    dataMinExame: 'O exame deve ser realizado no máximo 30 dias antes da solicitação.',
    deambulacao: 'Deambulação',
    dependenciaCompleta: 'Dependência completa',
    desejaImprimirEstacionario: 'Você deseja imprimir a G.A.S. do equipamento estacionário ?',
    desejaImprimirPortatil: 'Você deseja imprimir a G.A.S. do equipamento portátil ?',
    devolucao: 'Devolução',
    devolvendo: 'Devolvendo',
    mensagemAnexosObrigatorios: 'Você deve anexar a identidade com CPF, o comprovante de revidência e o termo da SMS para salvar a avaliação clínica.',
    devolver: 'Devolver',
    devolverOperador: 'Devolver ao solicitante',
    devolvido: 'Devolvido',
    doencaAutoimune: 'Doença autoimune',
    doencaNeurologica: 'Doença neurológica',
    doencasPulmonares: 'Doenças pulmonares',
    emitirGas: 'Emitir G.A.S.',
    empresaResponsavel: 'Empresa responsável',
    encaminhado: 'Encaminhado',
    encaminhado: 'Encaminhado',
    encaminhado: 'Encaminhado',
    encaminhadoAgendador: 'Solicitado',
    equipamentos: 'Equipamentos',
    equipamentosEstacionarios: 'Equipamentos estacionários',
    equipamentosPortateis: 'Equipamentos portáteis',
    erroCarregarProcesso: 'Ocorre um erro ao carregar o processo.',
    erroGerarGasometria: 'Ocorreu um erro ao gerar a gasometria. Tente novamente mais tarde.',
    erroGerarGasometria: 'Ocorreu um erro ao gerar a gasometria. Tente novamente mais tarde.',
    erroGerarGasometria: 'Ocorreu um erro ao gerar a gasometria. Tente novamente mais tarde.',
    erroGerarGasometria: 'Ocorreu um erro ao gerar a gasometria. Tente novamente mais tarde.',
    erroImprimirAvaliacaoClinica: 'Ocorre um erro ao imprimir a avaliação. Tente novamente mais tarde.',
    erroImprimirGasAvaliacaoClinica: 'Ocorre um erro ao imprimir o G.A.S. da avaliação clínica. Tente novamente mais tarde.',
    erroImprimirGasAvaliacaoClinica: 'Ocorre um erro ao imprimir o G.A.S. da avaliação clínica. Tente novamente mais tarde.',
    erroImprimirGasAvaliacaoClinica: 'Ocorre um erro ao imprimir o G.A.S. da avaliação clínica. Tente novamente mais tarde.',
    erroSolicitarEquipamento: 'Ocorreu um erro ao solicitar o equipamento. Tente novamente mais tarde.',
    erroSolicitarEquipamentoPortatil: 'Ocorreu um erro ao solicitar o equipamento portátil. Tente novamente mais tarde.',
    escalaPps: "Escala PPS",
    escalaPpsExtenso: 'Escala PPS (Palliative Performance Scale)',
    esforco: 'Atividades normais com esforço, alguma evidencia de doença',
    estacionario: 'Estacionário',
    estacionario: 'Estacionário',
    estacionarioPortatil: 'Estacionário e Portátil',
    estacionarioPortatil: 'Estacionário e Portátil',
    estacionarioPortatil: 'Estacionário e Portátil',
    exFumante: 'Ex-fumante',
    filaEstacionario: 'Fila de espera para equipamentos estacionários',
    filaGasEquipamentos: 'Fila de espera para equipamentos',
    filaPortatil: 'Fila de espera para equipamentos portáteis',
    fluxoOxigenio: 'Fluxo de Oxigênio (L/min)',
    fumante: 'Fumante',
    gasFilaEspera: 'O processo se encontra em fila de espera para a geração da G.A.S.',
    gasFilaEspera: 'O processo se encontra em fila de espera para a geração da G.A.S.',
    gasFilaEspera: 'O processo se encontra em fila de espera para a geração da G.A.S.',
    gasometriaArterial: 'Gasometria arterial',
    gasometriaUsoOxigenio: 'Gasometria com uso de oxigênio',
    geracaoGasFilaEspera: 'Não existem mais equipamentos disponíveis para o paciente. O mesmo foi colocado na fila de espera.',
    geracaoGasFilaEspera: 'Não existem mais equipamentos disponíveis para o paciente. O mesmo foi colocado na fila de espera.',
    geracaoGasMunicipioPlenoSucesso: 'A avaliação clínica foi vinculada a um equipamento com sucesso.',
    geracaoGasSucesso: 'A avaliação clínica foi vinculada a um equipamento com sucesso. O G.A.S. será agora gerado e um e-mail será enviado a empresa responsável pelo fornecimento do oxigênio.',
    geracaoGasSucesso: 'A avaliação clínica foi vinculada a um equipamento com sucesso. O G.A.S. será agora gerado e um e-mail será enviado a empresa responsável pelo fornecimento do oxigênio.',
    geradoPeloSistema: 'Movimentação gerada pelo sistema',
    geradoPeloSistema: 'Movimentação gerada pelo sistema',
    geradoPeloSistema: 'Movimentação gerada pelo sistema',
    hco3: 'Bicarbonato (HCO3)',
    hco3: 'HCO3',
    historicoSaude: 'Histórico de saúde',
    identificacaoResponsavel: 'Identificação do responsável',
    impedimentoSolicitacaoEquipamentoComplemento: 'Antes de solicitar um equipamento complementar para esta avaliação clínica, certifique-se de que o equipamento estacionário já foi liberado.',
    imprimindoAvaliacaoClinica: 'Imprimindo avaliação clínica',
    imprimirGas: 'Imprimir G.A.S.',
    imprimirGasEstacionario: 'Imprimir G.A.S. - Estacionário',
    imprimirGasPortatil: 'Imprimir G.A.S. - Portátil',
    incapazHobbies: 'Incapaz para hobbies ou trabalho doméstico, doença significativa',
    incapazTrabalho: 'Incapaz paro o trabalho, doença significativa',
    indeferido: 'Indeferido',
    indeferimento: 'Indeferimento',
    indeferindo: 'Indeferindo',
    indeferir: 'Indeferir',
    indicacaoClinica: 'Indicação clínica',
    informacoesClinicas: 'Informações clínicas',
    ingestao: 'Ingestão',
    ingestaoMinima: 'Mínima a pequenos goles',
    ingestaoParcial: 'Normal ou reduzida',
    instituicaoInternacao: 'Instituição de internação',
    instrucaoFilaGasEquipamento: 'Aqui, você pode visualizar os processos que estão aguardando a geração da G.A.S. para o fornecimento de oxigênio para cada equipamento.',
    internado: 'Internado(a)',
    limitado: 'Mínima a pequenos goles',
    morte: 'Morte',
    municipioGestaoPlena: 'Município em gestão plena',
    naFilaDeTransplante: 'Na fila de transplante',
    nenhumAcompanhanteEncontrado: 'Nenhum acompanhante encontrado. Deseja cadastrar um novo?',
    neoplasia: 'Neoplasia',
    nivelConsciencia: "Nível de Consciência",
    nivelConscienciaParcial: 'Completo ou com periodos de confusao',
    nomeEmpresaGas: 'Nome da empresa responsável',
    normal: 'Normal',
    normalComEvidencia: 'Atividades e trabalho normais, com evidencia de doença',
    normalSemEvidencia: 'Atividades e trabalho normais, sem evidencia de doença',
    novaAvaliacaoClinica: 'Nova avaliação clínica',
    novaSolicitacao: 'Nova solicitação',
    novidades: 'Novidades',
    numerGas: 'Número do G.A.S.',
    numeroGas: 'Número da G.A.S.',
    numeroGas: 'Número da G.A.S.',
    nuncaFumou: 'Nunca fumou',
    outrasCheckbox: 'Outra(s)',
    outrasDoencas: 'Outras doenças',
    outroParentesco: 'Outro parentesco',
    oxigenioPortatil: 'Oxigênio portátil',
    pacienteFilaTransplante: 'Paciente na fila de transplante',
    pacienteInternado: 'Paciente internado',
    pacienteLeitoRestricao: 'Paciente está restrito ao leito?',
    pacientePediatrico: 'Paciente pediátrico',
    pacienteReabilitacao: 'Paciente faz reabilitação pulmonar ou cardíaca?',
    pacienteRotina: 'Paciente tem uma rotina de vida diária ativa fora do seu domicílio?',
    pacienteRotinaDescricao: "Caso afirmativo, descreva as atividades e a frequência das mesmas",
    pacienteVentilacaoMecanica: 'Paciente é dependente de ventilação mecânica?',
    parcial: `Parcial`,
    parcialmenteAcamado: 'Maior parte do tempo acamado',
    parcialmenteAcamadoIncapaz: 'Incapaz para a maioria das atividades, doença extensa',
    parentesco: 'Grau de parentesco',
    pco2: 'pCO2',
    pco2: 'pCO2',
    periodoRenovacao: 'Período de renovação (em meses)',
    pesquisaAvaliacoesClinicas: 'Pesquisa de Avaliações Clínicas',
    pesquisaSolicitacoes: 'Pesquisa de Solicitações',
    ph: 'pH',
    ph: 'pH',
    po2: 'pO2',
    po2: 'pO2',
    porcentagem: 'Porcentagem: ',
    portatil: 'Portátil',
    portatil: 'Portátil',
    processoAvaliacaoClinica: 'Processo de avaliação clínica',
    producao: 'Produção',
    rascunho: 'Rascunho',
    redeOxigenoterapia: 'Rede de Oxigenoterapia',
    redeOxigenoterapia: 'Rede de Oxigenoterapia',
    reduzida: 'Reduzida',
    responsavelAdicionado: 'Responsável adicionado',
    responsavelPelaUnidade: 'Responsável pela unidade',
    responsavelPelaUnidade: 'Responsável pela unidade',
    responsavelSalvoSucesso: 'Responsável salvo com sucesso',
    responsavelSalvoSucesso: 'Responsável salvo com sucesso',
    resultados: 'Resultados',
    salvarCadastro: 'Deseja salvar o cadastro?',
    sat02: 'Sat02',
    semProcessosFila: 'Não existem processos na fila de espera para a geração da G.A.S. deste equipamento.',
    sentadoAcamado: 'Maior parte do tempo sentado ou acamado',
    sentadoAcamadoIncapaz: 'Incapacitado para qualquer trabalho, doença extensa',
    solicitacaoAvaliacaoClinica: 'Solicitação de avaliação clínica',
    solicitarEquipamento: 'Solicitar equipamento',
    solicitarPortatil: 'Solicitar portátil',
    sonolencia: 'Completa ou sonolência +/- confusão',
    tempoUsoOxigenio: 'Tempo de uso do oxigênio (h/dia)',
    textoConfirmacaoEnvioSolicitacao: 'Você confirma o envio da avaliação clínica?',
    textoConfirmacaoEnvioSolicitacao: 'Você confirma o envio da avaliação clínica?',
    textoConfirmarRascunhoSolicitacao: 'Deseja salvar um rascunho da avaliacao clínica?',
    textoConfirmarRascunhoSolicitacao: 'Deseja salvar um rascunho da avaliacao clínica?',
    tipoEquipamento: 'Tipo de equipamento',
    tipoEquipamentoSolicitado: 'Tipo de equipamento solicitado',
    tipoGestao: 'Tipo de gestão',
    total: "Total",
    totalmenteAcamado: 'Totalmente acamado',
    totalmenteAcamadoIncapaz: 'Incapaz para qualquer atividade, doença extensa',
    traqueostomia: 'Traqueostomia',
    tratamentosAndamento: 'Tratamentos em andamento',
    veracidadeIndicacaoClinica: 'Assumo a veracidade das informações acima descritas, com base em visita domiciliar, documentação apresentada, bem como das declarações recebidas do paciente.',
    verde: 'Verde',
    vermelho: 'Vermelho'
};
